import { useModuleBEM, useSelfServeStyles } from "@b2bportal/core-themes";
import {
  type BookingType,
  CallState,
  CoreSelfServeComponent,
} from "@overrides/types";
import {
  ResendEmailForm,
  ResendError,
  ResendProcessing,
  ResendSuccess,
  useResendEmail,
} from "@tenant/self-serve";
import clsx, { type ClassValue } from "clsx";

import defaultStyles from "../ResendEmailModal.module.scss";

export interface IResendEmailModalContentProps {
  className?: ClassValue;
  isLuxuryHotel?: boolean;
  /**
   * UUID passed along in the send email request.
   * Itinerary ID for flights, reservation ID for hotels, ground, homes, etc.
   */
  reservationId: string;
  reservationType: BookingType;
  initialValue?: string;
}

export const ResendEmailModalContent = (
  props: IResendEmailModalContentProps
) => {
  const {
    className,
    isLuxuryHotel = false,
    reservationId,
    reservationType,
    initialValue,
  } = props;
  const COMPONENT_KEY = CoreSelfServeComponent.ResendEmailModal;
  const { copy, context, handlers } = useResendEmail(
    reservationId,
    reservationType,
    isLuxuryHotel
  );
  const styles = useSelfServeStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <div className={clsx(block, className)}>
      {context.reqState === CallState.NotCalled && (
        <ResendEmailForm
          cn={cn}
          copy={copy}
          resendEmail={handlers.onSubmit}
          initialValue={initialValue}
        />
      )}
      {context.reqState === CallState.InProcess && (
        <ResendProcessing cn={cn} copy={copy} />
      )}
      {context.reqState === CallState.Success && (
        <ResendSuccess cn={cn} copy={copy} />
      )}
      {context.reqState === CallState.Failed && (
        <ResendError
          cn={cn}
          copy={copy}
          onTryAgain={() => handlers.setReqState(CallState.NotCalled)}
        />
      )}
    </div>
  );
};
